var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"asset-stock","category-name":"資産運用（株式）"}})}
var staticRenderFns = []

export { render, staticRenderFns }